import { Callout } from "../components/Callout.js";

export const meta = {
  title: "ステータス自動連携",
  updatedAt: "2026-07-23",
};

export function Content() {
  return (
    <>
      <p>
        送信後、ユーザーが何もしなくても、書類の締結状況が
        15 分間隔で HubSpot プロパティへ自動同期されます。
      </p>

      <h2>同期されるステータス</h2>
      <ul>
        <li><strong>下書き</strong>: クラウドサインに書類が作成された直後</li>
        <li><strong>送信済み</strong>: 受信者へ署名依頼が発信された</li>
        <li><strong>顧客署名済</strong>: 一部の受信者が署名を終えた</li>
        <li><strong>締結完了</strong>: すべての受信者が署名完了した</li>
        <li><strong>却下</strong>: 受信者の誰かが拒否した</li>
        <li><strong>期限切れ</strong>: 送信から一定期間署名されなかった</li>
      </ul>

      <h2>同期される情報</h2>
      <p>ステータスに加え、以下も常に同期されます:</p>
      <ul>
        <li>書類 ID</li>
        <li>下書き URL（クラウドサインの書類画面リンク）</li>
        <li>締結完了 URL（締結後のリンク）</li>
        <li>締結済 PDF / 合意締結証明書（プロパティ設定で「再アップロード」を選んだ場合）</li>
      </ul>

      <h2>同期のタイミング</h2>
      <ul>
        <li><strong>送信時</strong>: 即時、初期値（下書きステータス）を書き込み</li>
        <li><strong>15 分ごと</strong>: バックグラウンドジョブで変化を検知して書き込み</li>
      </ul>

      <Callout type="info" title="リアルタイムではない">
        クラウドサイン側で署名された瞬間に HubSpot に反映されるわけではありません。
        最大 15 分の遅延があります。
      </Callout>

      <h2>同じレコードで複数回送信した場合の挙動</h2>
      <p>
        同じ HubSpot レコードに対して書類を 2 回以上送信した場合、HubSpot プロパティには
        <strong>常に最新の書類のステータス</strong>が反映されます。
      </p>
      <p>
        新しく送信した書類がクラウドサイン側で削除されるなどして取得できなくなった
        場合は、その 1 つ前に送信した書類（クラウドサインに残っているもの）の
        ステータスと URL に自動で戻します。これにより、誤って削除した書類の影響で
        HubSpot のステータスが古い「下書き」のまま固着してしまうことを防ぎます。
      </p>
      <Callout type="info" title="具体例">
        同じ取引に対して「書類 A → 送信済み」「書類 B → 下書き」と続けて送信したあと、
        書類 B をクラウドサインから削除した場合、自動同期によって HubSpot プロパティは
        「書類 A の送信済み + 書類 A の URL」に書き戻されます。
      </Callout>

      <h2>同期が動かない時の確認ポイント</h2>
      <ul>
        <li>
          <strong>Client ID が有効か</strong>: 接続設定タブで Client ID の
          「接続テスト」を実行し、「接続成功」と表示されるか確認してください
        </li>
        <li>
          <strong>環境が一致しているか</strong>: 本番で送信した書類のステータスは
          sandbox の Client ID では取得できません。逆も同様です
        </li>
        <li>
          <strong>書類が削除されていないか</strong>: クラウドサイン側で削除された書類は
          自動で「取得不可」として扱われ、以降は同期されません
        </li>
        <li>
          <strong>HubSpot との接続が有効か</strong>: HubSpot 側でアプリを削除した場合、
          再接続が必要です
        </li>
      </ul>

      <Callout type="tip" title="手動同期はできない">
        現在、手動でステータスを再取得する機能はありません。15 分の自動同期を
        お待ちください。
      </Callout>
    </>
  );
}
